export default class OsobaService {
  constructor(server, KontaktService){
    this.server = server;
    this.KontaktService = KontaktService;
  }
 
  get(id){
    return this.server("osoba.get", {id: id});
  }

  save(id, item){
    return this.server("osoba.update", {id: id, data: item});
  }

  create(kontaktId){
    return this.get(0).then(osoba => this.KontaktService.get(kontaktId).then(kontakt => ({
      ...osoba,
      kontakt
    })));
  }

}


// WEBPACK FOOTER //
// ./src/Osoba/OsobaService.js